const messages = {
    hm: null,
    // Inline toast template. The toast/header/body/close-button class slots are
    // theme-owned cssClassesMap keys ({$toastTemplate} / {$toastHeader} /
    // {$toastBody} / {$toastCloseButton}) resolved in show() — hm is not yet
    // assigned at module-eval time, so they cannot be baked in here.
    // The `data-zit-subelement-type` markers are the JS contract for structural
    // reach-in (icon insert, severity-text-class swap) — we never query by
    // class name from JS.
    // The close button carries data-zit-dismiss="toast"; bridgeTierAttrs
    // (called inside show() before behaviors.toast.show) mirrors it onto
    // data-bs-dismiss so Bootstrap.Toast wires its built-in close handler.
    template: '<div class="{$toastTemplate} zit-border" role="alert" aria-live="assertive" aria-atomic="true"><div class="{$toastHeader} {$toastHeaderTextSize}" data-zit-subelement-type="header"><strong class="zit-me-auto">{$title}</strong><button type="button" class="{$toastCloseButton}" data-zit-dismiss="toast" aria-label="Close"></button></div><div class="{$toastBody} zit-p-5 {$toastBodyTextSize}" data-zit-subelement-type="body">{$content}</div></div>',
    // Per-message-type style. iconName is a semantic name from the icon
    // contract (see scripts/icons.contract.md); the actual icon class string
    // is resolved from this.hm.app.icons[iconName] at show-time, after the
    // theme's icon map has been loaded by the xhr/icons fetch.
    styleConfigs: {
        // textClass / borderClass are cssClassesMap labels (resolved via
        // hm.app.cssClass at show-time), not literal Bootstrap classes.
        error:   { iconName: 'notifyDanger',  textClass: 'textDanger',  borderClass: 'borderDanger'  },
        warning: { iconName: 'notifyWarning', textClass: 'textWarning', borderClass: 'borderWarning' },
        info:    { iconName: 'notifyInfo',    textClass: 'textInfo',    borderClass: 'borderInfo'    },
        success: { iconName: 'notifySuccess', textClass: 'textSuccess', borderClass: 'borderSuccess' },
        default: { iconName: 'notifyPrimary', textClass: 'textPrimary', borderClass: 'borderPrimary' }
    },
    stackElement: null,

    init: function () {
        this.stackElement = document.getElementById('kt_docs_toast_stack_container');
    },

    show: function (message) {
        if (Array.isArray(message)) {
            message.forEach((msg) => {
                this.show(msg);
            });
        } else {
            let styleConfig = typeof this.styleConfigs[message.type] !== typeof undefined ? this.styleConfigs[message.type] : this.styleConfigs.default;

            let toastHtml = this.template;

            // Resolve the theme-owned class slots (toast/header/body/close button)
            toastHtml = toastHtml.replace('{$toastTemplate}', this.hm.app.cssClass('toastTemplate'));
            toastHtml = toastHtml.replace('{$toastHeader}', this.hm.app.cssClass('toastHeader'));
            toastHtml = toastHtml.replace('{$toastCloseButton}', this.hm.app.cssClass('toastCloseButton'));
            toastHtml = toastHtml.replace('{$toastBody}', this.hm.app.cssClass('toastBody'));
            // Toast text sizes are theme-owned cssClassesMap keys, resolved here
            // like the other slots (hm not available at module-eval time).
            toastHtml = toastHtml.replace('{$toastHeaderTextSize}', this.hm.app.cssClass('textSizeNormal'));
            toastHtml = toastHtml.replace('{$toastBodyTextSize}', this.hm.app.cssClass('textSizeSmall'));

            toastHtml = toastHtml.replace('{$title}', this.hm.app.utext(message.type));
            toastHtml = toastHtml.replace('{$content}', this.hm.app.utext(message.text));

            let toastNode = this.hm.helper.string2element(toastHtml);
            // Resolve the severity border label to the theme's class string(s).
            toastNode.classList.add(...this.hm.app.cssClass(styleConfig.borderClass).split(' '));

            // Build the icon HTML from the theme's icon map; fall back to no
            // icon (empty class) if the theme didn't declare this name.
            let iconClass = this.hm.app.icons[styleConfig.iconName] ?? '';
            let iconHtml = '<i class="' + this.hm.app.cssClass(styleConfig.textClass) + ' ' + this.hm.app.cssClass('iconSizeRegular') + ' ' + iconClass + ' zit-me-3"></i>';
            let iconElement = this.hm.helper.string2element(iconHtml);

            // Reach into the toast structure via zit-namespaced subelement markers
            // (the classes themselves stay for Bootstrap's CSS to style the toast).
            let toastHeader = toastNode.querySelector('[data-zit-subelement-type="header"]');
            let toastBody = toastNode.querySelector('[data-zit-subelement-type="body"]');
            toastHeader.prepend(iconElement);
            // Resolve the severity text label to the theme's class string(s).
            let severityTextClass = this.hm.app.cssClass(styleConfig.textClass);
            toastHeader.classList.add(...severityTextClass.split(' '));
            toastBody.classList.add(...severityTextClass.split(' '));

            this.stackElement.append(toastNode);

            // Bridge the toast subtree's zit-namespaced markup onto the tier's
            // framework-namespaced equivalents (zb5 mirrors data-zit-dismiss="toast"
            // onto data-bs-dismiss so Bootstrap.Toast wires the close button).
            // Tier no-op when the tier doesn't need bridging.
            this.hm.behaviors.bridgeTierAttrs(toastNode);

            // One-shot show via the theme's behaviour adapter. The contract's
            // toast.show is the only entry point — the adapter handles
            // instance reuse / lifecycle internally (bootstrap5 uses
            // bootstrap.Toast.getOrCreateInstance).
            this.hm.behaviors.toast.show(toastNode);
        }
    }
};

module.exports = messages;
